module.exports = __webpack_public_path__ + "img/pro_campaigns_banner_thryv.ae6d4a57.png";